
import { Options, Vue } from 'vue-class-component'
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, {
  // 设置底部小圆点
  Pagination,
  // 设置两边的箭头
  Navigation,
  // 动画效果
  EffectCoverflow,
  // 自动播放
  Autoplay
} from 'swiper';

import "swiper/swiper-bundle.css"

SwiperCore.use([Pagination, Navigation, EffectCoverflow, Autoplay]);


@Options({
  components: {
    Swiper,
    SwiperSlide
  },
  props: ['data'],
})
export default class Topic extends Vue {}
